import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/modal/modal.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * The 'ui.bootstrap' and confirmCustom controller module deps are preserved so
 * ModalService.confirm()'s `$uibModal.open({ controller: 'ConfirmCustomModalController' })`
 * still resolves at runtime, and consumers depending on ModalServiceModule
 * keep transitively loading them.
 */
export { ModalService } from '@ng/core/modal/modal.service';

export const ModalServiceModule = angular.module('acme.common.service.modal', [
  'ui.bootstrap',
  'acme.view.application.modals.confirmCustom.controllers',
]).name;
